(() => {
  function initialiseProductAccordions() {
    document.querySelectorAll('[data-product-accordions]').forEach((root) => {
      if (root.dataset.accordionsReady) return;
      const mobile = window.matchMedia('(max-width: 749px)');
      const items = Array.from(root.querySelectorAll('.tablink')).map((tab) => {
        const panel = root.querySelector('[id="' + tab.getAttribute('tab-target') + '"]');
        if (!panel) return null;
        const heading = document.createElement('h2');
        heading.className = 'product-information__heading';
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'custom-maps-hub__faq-trigger';
        button.id = panel.id + '-accordion-trigger';
        button.setAttribute('aria-controls', panel.id);
        const label = document.createElement('span');
        label.textContent = tab.textContent.trim();
        const icon = document.createElement('span');
        icon.textContent = '+';
        icon.setAttribute('aria-hidden', 'true');
        button.append(label, icon);
        heading.append(button);
        panel.before(heading);
        const item = { panel, button, open: panel.id === 'AboutDesign' };
        button.addEventListener('click', () => {
          item.open = !item.open;
          updateItem(item);
        });
        // Keep the existing rating-summary link into Reviews working on mobile.
        tab.addEventListener('click', () => {
          if (!mobile.matches) return;
          item.open = true;
          updateItem(item);
        });
        return item;
      }).filter(Boolean);

      function updateItem(item) {
        item.button.setAttribute('aria-expanded', String(item.open));
        if (mobile.matches) {
          item.panel.hidden = !item.open;
          item.panel.setAttribute('role', 'region');
          item.panel.setAttribute('aria-labelledby', item.button.id);
        } else {
          item.panel.removeAttribute('hidden');
          item.panel.removeAttribute('role');
          item.panel.removeAttribute('aria-labelledby');
        }
      }

      mobile.addEventListener('change', () => items.forEach(updateItem));
      items.forEach(updateItem);
      root.dataset.accordionsReady = 'true';
    });
  }
  initialiseProductAccordions();
  document.addEventListener('shopify:section:load', initialiseProductAccordions);
})();
